import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-app-type-notice-modal',
  templateUrl: './app-type-notice-modal.component.html',
  styleUrls: ['./app-type-notice-modal.component.scss']
})
export class AppTypeNoticeModalComponent implements OnInit {
  currApplicationType: string = '';
  highestEducation: string = '';
  noticeContent: string = '';
  noticeHeading: string = '';
  buttonText: string = '';
  showProceedButton: boolean = false;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly sessionStorage: LocalService
  ) {
  }

  ngOnInit(): void {
    this.getCurrApplicationTypeFromSession();
    this.getHighestEducationFromSession();
    this.setNoticeContent();
  }

  getCurrApplicationTypeFromSession(): void {
    this.currApplicationType = this.sessionStorage.getItem('currApplicationType') || '';
  }

  getHighestEducationFromSession(): void {
    this.highestEducation = this.sessionStorage.getItem('highestEducation') || '';
  }

  setNoticeContent(): void {
    const isHighSchoolOrGED = this.highestEducation === 'High School Diploma or Equivalent';
    
    // Emergency Substitute and education level above High School
    if (this.currApplicationType === 'Emergency Substitute' && !isHighSchoolOrGED) {
      this.noticeHeading = 'You have selected an education level above High School.';
      this.noticeContent = 'This application will be processed as a Substitute application rather than an Emergency Substitute application. Your current progress will be retained.';
      this.buttonText = 'Proceed with Substitute Application';
      this.showProceedButton = true;
    }
    // Substitute and High School/GED education
    else if (this.currApplicationType === 'Substitute' && isHighSchoolOrGED) {
      this.noticeHeading = 'You have selected High School as your highest level of education.';
      this.noticeContent = 'This application will be processed as an Emergency Substitute application rather than a Substitute application. Your current progress will be retained.';
      this.buttonText = 'Proceed with Emergency Substitute Application';
      this.showProceedButton = true;
    }
    // ARL or Regular - Initial and High School/GED education
    else if ((this.currApplicationType === 'ARL' || this.currApplicationType === 'Regular - Initial') && isHighSchoolOrGED) {
      this.noticeHeading = 'You have selected High School as your highest level completed.';
      this.noticeContent = `${this.currApplicationType} applications require a bachelor's degree or higher. Please review your education level and make any necessary changes to continue with this application.`;
      this.showProceedButton = false;
    }
    // Default case - keeping original content
    else {
      this.noticeHeading = 'You have selected High School as your highest level of education.';
      this.noticeContent = 'This application will be processed as an Emergency Substitute application rather than a Substitute application. Your current progress will be retained.';
      this.showProceedButton = false;
    }
  }

  modalClose() {
    this.activeModal.close();
  }

  proceedWithApplication() {
    // Close modal and proceed with application
    this.activeModal.close('proceed');
  }

}
